import { Box } from '@uptime/design-system/components/Box';

import { ListItem } from './ListItem';

interface Props {
  to: string;
  children: React.ReactNode;
  onClick?: () => void;
  selected?: boolean;
}

export const CollapsableListSubItem = ({ to, children, onClick, selected }: Props) => (
  <ListItem to={to} onClick={onClick} selected={selected} data-testid="leftMenuItem">
    <Box sx={{ width: 32 }} />
    {children}
  </ListItem>
);
